import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {errorRoute} from './layouts/error/error.route';
import {navbarRoute} from './layouts/navbar/navbar.route';
import {DEBUG_INFO_ENABLED} from 'app/app.constants';
import {HomeComponent} from "./home/home.component";


@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {path: 'lista-servizi', component: HomeComponent, data:{pageTitle: 'home.title'}},
        {
          path: '',
          loadChildren: () => import(`./appuntamenti/appuntamenti-routing.module`).then(m => m.AppuntamentiRoutingModule)
        },
        {
          path: '',
          loadChildren: () => import(`./entities/entity-routing.module`).then(m => m.EntityRoutingModule)
        },
        {
          path: '',
          loadChildren: () => import(`./settings/impostazioni-routing-module`).then(m => m.ImpostazioniRoutingModule)
        },
        {
          path: '',
          loadChildren: () => import(`./tributi/tributi-routing-module`).then(m => m.TributiRoutingModule)
        },
        {
          path: 'ca',
          pathMatch:"full",
          redirectTo: '/',
        },
        navbarRoute,
        ...errorRoute,
      ],
      {enableTracing: DEBUG_INFO_ENABLED}
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
